export const PREPARATION_TIMEOUT_MS = 15_000
export async function boundedPreparation<T>(run: (signal: AbortSignal) => Promise<T>, timeoutMs = PREPARATION_TIMEOUT_MS): Promise<T> {
  const controller = new AbortController()
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([Promise.resolve().then(() => run(controller.signal)), new Promise<never>((_, reject) => {
      timer = setTimeout(() => { controller.abort(); reject(Object.assign(Error('לא התקבלה תשובה לבדיקת הגרסאות וקישור המשימה בתוך 15 שניות. לא נרשם אישור.'), {code:'workflow_prepare_timeout'})) }, timeoutMs)
    })])
  } finally { clearTimeout(timer) }
}
export function preparationFailure(error: unknown): string {
  const code = String((error as {code?:unknown})?.code ?? (error instanceof Error ? error.message : ''))
  if (/inventory_timeout/.test(code)) return 'GitHub לא השלים את בדיקת כל ה־PR המקושרים בזמן. לא נרשם אישור.'
  if (/identity_timeout|files_timeout|sql_timeout/.test(code)) return 'GitHub לא השלים את אימות הגרסה וקובצי ה־SQL בזמן. לא נרשם אישור.'
  if (/github_permission/.test(code)) return 'לאפליקציית השחרורים חסרה הרשאת קריאה ב־GitHub. לא נרשם אישור.'
  if (/github_unavailable/.test(code)) return 'GitHub לא זמין כרגע לבדיקת הגרסאות. לא נרשם אישור.'
  if (/repos_timeout|tasks_timeout/.test(code)) return 'שרת המשימות לא השלים את אימות קישור המשימה בזמן. לא נרשם אישור.'
  if (/workflow_prepare_timeout/.test(code)) return 'לא התקבלה תשובה לבדיקת הגרסאות וקישור המשימה בתוך 15 שניות. לא נרשם אישור.'
  return error instanceof Error && /[א-ת]/.test(error.message) ? error.message : 'לא הצלחנו לאמת את הגרסאות וקישור המשימה. לא נרשם אישור.'
}
export function decisionDisabledReason(input: {allowed:boolean;hard:string;busy:boolean;preparing:boolean;prepared:boolean;current:boolean;confirmed:boolean;validReason:boolean;approved:boolean;error:string}) {
  if (!input.allowed) return 'האישור זמין לניצן בלבד, בחיבור פעיל לאתר החי.'
  if (input.busy) return 'האישור נשמר. יש להמתין לתוצאת השמירה.'
  if (input.hard) return input.hard
  if (input.approved) return 'האישור כבר נרשם לגרסה המוצגת.'
  if (input.preparing) return 'מאמת את הגרסאות וקישור המשימה — עד 15 שניות.'
  if (!input.prepared || !input.current) return input.error ? 'הבדיקה לא הושלמה. יש ללחוץ על ״נסה שוב״.' : 'יש להשלים את בדיקת הגרסאות לפני האישור.'
  if (!input.validReason) return 'יש לכתוב סיבה בת 5–2000 תווים, ללא ירידת שורה.'
  if (!input.confirmed) return 'יש לסמן את אישור הגרסאות המדויקות.'
  return ''
}
